import { render, staticRenderFns } from "./IxButton.vue?vue&type=template&id=7b52b983&scoped=true&lang=html&"
import script from "./IxButton.vue?vue&type=script&lang=js&"
export * from "./IxButton.vue?vue&type=script&lang=js&"
import style0 from "./IxButton.vue?vue&type=style&index=0&id=7b52b983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52b983",
  null
  
)

export default component.exports